import Vue from 'vue'
import Router from 'vue-router'

import Main from '../pages/Service/Main.vue';
import PersonalArea from '../pages/PersonalArea.vue';
import Error from '../pages/Service/error.vue';
import callback from '../pages/Service/callback.vue';
import Fines from '../pages/Dictionaries/Fines.vue';
import Partners from '../pages/Partners.vue';
import Cars from '../pages/Dictionaries/Cars.vue';
import Cities from '../pages/Dictionaries/Cities.vue';
import PartnerBranches from '../pages/Dictionaries/PartnerBranches.vue';
import Bonuses from '../pages/Dictionaries/Bonuses.vue';
import Stocks from '../pages/Stocks.vue';
import ActivateBonus from '../pages/ActivateBonus.vue'
import Statistic from '../pages/Statistics.vue'
import Staff from '../pages/Staff.vue';
import Orders from '../pages/Orders.vue';
import Clients from '../pages/Clients.vue';
import Requests from '../pages/Requests.vue';
import StatisticDetails from '../pages/StatisticDetails.vue'

Vue.use(Router);


export default new Router({
  mode: 'history',
  routes: [
    { path: '*', redirect: 'Error/404' },
    { path: '/', redirect: '/Main' },
    {
      path: '/callback',
      name: 'callback',
      component: callback,
      meta:{
        requiresAuth: false
      },
    },
    {
      path: '/Main',
      name: 'Main',
      component: Main,
      meta:{
        requiresAuth: false
      },
    },

    {
      path: '/Partners',
      name: 'Partners',
      component: Partners,
      meta:{
        accessRole:['Administrator', 'Support'],
        requiresAuth: true
      },
    },
    {
      path: '/Cars',
      name: 'Cars',
      component: Cars,
      meta:{
        accessRole:['Administrator', 'UserManager', 'Support'],
        requiresAuth: true
      },
    },
      {
          path: '/Staff',
          name: 'Staff',
          component: Staff,
          meta:{
              accessRole:['Administrator', 'UserManager', 'Support'],
              requiresAuth: true
          },
      },
    {
      path: '/Cities',
      name: 'Cities',
      component: Cities,
      meta:{
        accessRole:['Administrator', 'Support'],
        requiresAuth: true
      },
    },
    {
      path: '/Stocks',
      name: 'Stocks',
      component: Stocks,
      meta:{
        accessRole:['Administrator', 'Support'],
        requiresAuth: true
      },
    },
      {
          path: '/Statistic',
          name: 'Statistic',
          component: Statistic,
          meta:{
              accessRole:['Administrator', 'Support'],
              requiresAuth: true
          },
      },
      {
          path: '/Statistic/Details',
          name: 'StatisticDetails',
          component: StatisticDetails,
          meta:{
              accessRole:['Administrator', 'Support'],
              requiresAuth: true
          },
      },
    {
      path: '/Bonuses',
      name: 'Bonuses',
      component: Bonuses,
      meta:{
        accessRole:['Administrator','Support','Client'],
        requiresAuth: true
      },
    },
    {
      path: '/Branches',
      name: 'Branches',
      component: PartnerBranches,
      meta:{
        accessRole:['Administrator', 'Support', 'Client'],
        requiresAuth: true
      },
    },
    {
      path: '/Fines',
      name: 'Fines',
      component: Fines,
      meta:{
        accessRole:['Administrator', 'Support'],
        requiresAuth: true
      },
    },
      {
          path: '/ActivateBonus',
          name: 'ActivateBonus',
          component: ActivateBonus,
          meta:{
              accessRole:['RequestExecutor', 'Administrator'],
              requiresAuth: true
          },
      },
    {
      path: '/Orders',
      name: 'Orders',
      component: Orders,
      meta:{
        accessRole:['RequestExecutor', 'Administrator'],
        requiresAuth: true
      },
    },
    {
      path: '/Clients',
      name: 'Clients',
      component: Clients,
      meta:{
        accessRole:['Client','UserManager', 'Administrator'],
        requiresAuth: true
      },
    },
      {
          path: '/Clients_ReadOnly',
          name: 'Clients_ReadOnly',
          component: Clients,
          meta:{
              accessRole:['Client','UserManager', 'Administrator'],
              requiresAuth: true
          },
      },
    {
      path: '/Requests',
      name: 'Requests',
      component: Requests,
      meta:{
        accessRole:['RequestExecutor', 'Administrator'],
        requiresAuth: true
      },
    },
    {
      path: '/PersonalArea',
      name: 'PersonalArea',
      component: PersonalArea,
      meta:{
        requiresAuth: true,
        accessRole:['Administrator', 'RequestExecutor', 'UserManager','BonusManager', 'Support', 'Client'],
      },
    },
    {
      path: '/Error/:errorCode',
      name: 'Error',
      component: Error,
      meta: {
        requiresAuth: false
      }
    },

  ]
})
